export default "__VITE_ASSET__BrfaXNL7__"